<div class="card">
	<div class="p-grid">
		<div class="p-col-12 p-lg-6 d-flex flex-column">
			<div>External ID Menu Item</div>
			<div class="descriptionText">When rang, the text of this item will be used as the <em>externalId</em> for a check.</div>
			<div>
				<span class="p-float-label mt-4">
					<p-dropdown
						#externalMenuItemSelect
						[options]="menuItemList"
						optionLabel="name"
						optionValue="menuItemKey"
						name="externalMenuItemSelect"
						[(ngModel)]="venueSvc.subscriptionVenue.value.externalIdMenuItemKey"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
						[virtualScroll]="true"
						itemSize="30"
						filter="true"
						(filterBy)="app.keys(menuItemList)"
					></p-dropdown>
					<label for="externalMenuItemSelect">External Reference ID Menu Item</label>
				</span>
			</div>
		</div>
	</div>
</div>
